import React from "react";
import Modal from "../../../../elements/Modal";
import ManageProject from "../ManageProject";

const ManageProjectModal = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  return (
    <Modal isOpen={open} setIsOpen={close} size="xl2" title={data?._id?"Update":"Create New "}>
      <ManageProject getResponse={getResponse} close={close} data={data} />
    </Modal>
  );
};

export default ManageProjectModal;
